import { ApplianceModel, CutoutModel } from '../models';
import useAppliance from './useAppliance';

import { useApplianceContext } from '~/legacy/easy-estimator-page/context';
import { applianceDragStart } from '~/legacy/easy-estimator-page/context/applianceContext.utils';
import { useAppSelector } from '~/redux/hooks';
import { selectFabricCanvas } from '~/redux/slices/fabric';

export type DraggableAppliance = CutoutModel | ApplianceModel;

type useDragAndDropReturn = {
  handleDrag: () => void;
  handleDragStart: (args: {
    appliance: DraggableAppliance;
  }) => (e: React.DragEvent<HTMLImageElement>) => void;
  handleDragEnd: (callback?: () => void) => void;
};

export const useDragAndDrop = (): useDragAndDropReturn => {
  const {
    isDraggingAppliance,
    updateIsDraggingAppliance,
    updateOnDropAppliance,
  } = useApplianceContext();
  const { syncCookingAppliancesCount } = useAppliance();

  const canvas = useAppSelector(selectFabricCanvas);

  const handleDragStart =
    (args: { appliance: DraggableAppliance }) =>
    (e: React.DragEvent<HTMLImageElement>) => {
      const { appliance } = args;

      updateOnDropAppliance(undefined);
      applianceDragStart({ e, model: appliance, baseWidth: canvas.getZoom() });
    };

  const handleDrag = () => {
    if (!isDraggingAppliance) {
      updateIsDraggingAppliance(true);
    }
  };

  const handleDragEnd: useDragAndDropReturn['handleDragEnd'] = (callback) => {
    updateIsDraggingAppliance(false);

    syncCookingAppliancesCount();

    callback?.();
  };

  return {
    handleDrag,
    handleDragStart,
    handleDragEnd,
  };
};
